module.exports = __webpack_public_path__ + "img/antes_despues_253.a6685520.png";